export default __webpack_public_path__ + "static/media/Energy Cycle.2b3926c6.png";